import {gql} from "@apollo/client";
import {Garage} from "@App/types";

export interface GarageReviewsQuery {
    garage: Garage
}

export const GET_GARAGE_REVIEWS = gql`
    query getGarageReviews($id: ID!) {
        garage(id: $id) {
            reviews {
                id
                author
                comment
                rating
                cleanliness
                quality
                punctuality
                competence
                kindness
                published_at
                is_verified
                vendor_name
            }
        }
    }
`
